import { useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { HIT_TEXT, RUNNER_TEXT } from "@/lib/jobs";

export const GameDayPicker = ({ open, onOpenChange, selected, candidates, onSave }) => {
  const [keys, setKeys] = useState(selected.map((p) => p.key));
  const all = [...selected, ...candidates.filter((c) => !selected.some((s) => s.key === c.key))];
  const byKey = Object.fromEntries(all.map((p) => [p.key, p]));
  const rest = all.filter((p) => !keys.includes(p.key));
  const move = (idx, d) => setKeys((k) => {
    const n = [...k];
    [n[idx], n[idx + d]] = [n[idx + d], n[idx]];
    return n;
  });
  const Row = ({ p, children }) => (
    <div className="custom-item !cursor-default flex items-center gap-2">
      <div className="flex-1 min-w-0">
        <span className="chip">{HIT_TEXT[p.hit_type]} · {p.fielder} · {p.outs} out · {RUNNER_TEXT[p.runners]}</span>
        <p className="text-sm font-semibold mt-1 line-clamp-2">{p.explanation}</p>
      </div>
      {children}
    </div>
  );
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto" data-testid="gameday-picker">
        <SheetHeader><SheetTitle className="font-heading text-2xl uppercase">Game day plays ({keys.length})</SheetTitle></SheetHeader>
        <div className="space-y-2 mt-4">
          {keys.map((k, idx) => (
            <Row key={k} p={byKey[k]}>
              <div className="flex flex-col gap-1">
                <button className="icon-btn !min-h-[34px] !min-w-[34px]" data-testid="gameday-move-up" disabled={idx === 0} onClick={() => move(idx, -1)} aria-label="Move up"><ArrowUp size={16} /></button>
                <button className="icon-btn !min-h-[34px] !min-w-[34px]" data-testid="gameday-move-down" disabled={idx === keys.length - 1} onClick={() => move(idx, 1)} aria-label="Move down"><ArrowDown size={16} /></button>
              </div>
              <input type="checkbox" checked onChange={() => setKeys((ks) => ks.filter((x) => x !== k))} className="w-5 h-5" data-testid="gameday-selected-checkbox" />
            </Row>
          ))}
          {rest.length > 0 && <p className="ctl-label pt-3">Not on game day</p>}
          {rest.map((p) => (
            <Row key={p.key} p={p}>
              <input type="checkbox" checked={false} onChange={() => setKeys((ks) => [...ks, p.key])} className="w-5 h-5" data-testid="gameday-available-checkbox" />
            </Row>
          ))}
          <button className="btn-primary w-full !mt-4" data-testid="gameday-save-button" onClick={() => onSave(keys)}>Save game day list</button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
